import { SET_APIS } from '../types';

export const setAPIs = (data) => (dispatch) => {
  dispatch({
    type: SET_APIS,
    payload: data,
  });
};
